/**
 * pages/admin/healthCheck/StatusBadge.tsx
 *
 * Rendering helpers for HealthCheck status: icon, background, label text and color.
 */

import { CheckCircle, XCircle, AlertTriangle, RefreshCw } from 'lucide-react';
import type { CheckStatus } from './types';

export function StatusIcon({ status }: { status: CheckStatus }) {
  if (status === 'pending') return <div className="w-5 h-5 rounded-full border-2 border-neutral-300 bg-neutral-100" />;
  if (status === 'running') return <RefreshCw className="w-5 h-5 text-primary-500 animate-spin" />;
  if (status === 'ok') return <CheckCircle className="w-5 h-5 text-success-500" />;
  if (status === 'warning') return <AlertTriangle className="w-5 h-5 text-accent-500" />;
  return <XCircle className="w-5 h-5 text-error-500" />;
}

export function statusBg(status: CheckStatus): string {
  if (status === 'ok') return 'bg-success-50 border-success-200';
  if (status === 'warning') return 'bg-accent-50 border-accent-200';
  if (status === 'error') return 'bg-error-50 border-error-200';
  if (status === 'running') return 'bg-primary-50 border-primary-200';
  return 'bg-white border-neutral-200';
}

export function statusLabel(status: CheckStatus): string {
  if (status === 'ok') return 'OK';
  if (status === 'warning') return 'Attention';
  if (status === 'error') return 'Erreur';
  if (status === 'running') return 'En cours...';
  return 'En attente';
}

export function statusLabelColor(status: CheckStatus): string {
  if (status === 'ok') return 'text-success-700 bg-success-100';
  if (status === 'warning') return 'text-accent-700 bg-accent-100';
  if (status === 'error') return 'text-error-700 bg-error-100';
  if (status === 'running') return 'text-primary-700 bg-primary-100';
  return 'text-neutral-500 bg-neutral-100';
}

export function statusDetailColor(status: CheckStatus): string {
  if (status === 'error') return 'text-error-700';
  if (status === 'warning') return 'text-accent-700';
  return 'text-neutral-600';
}
